export default __webpack_public_path__ + "static/media/banner-top.4202a628.webp";